import { render, staticRenderFns } from "./RecipeStats.vue?vue&type=template&id=7f1ab25e"
import script from "./RecipeStats.vue?vue&type=script&lang=js"
export * from "./RecipeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports